import React from 'react'

const Name = () => {
  return (
    <>
      <span>Gloria's Serenity Home Health</span>
    </>
  )
}

export default Name